export default [
  {
    path: '/yiyuanjieshao',
    name: 'yiyuanjieshao',
    meta: { title: '医院介绍' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/yiyuanjieshao/yiyuanjieshao')
  },
  {
    path: '/tMap',
    name: 'tMap',
    meta: { title: '导航' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/tMap/tMap')
  },
  {
    path: '/dynamicInfo',
    name: 'dynamicInfo',
    meta: { title: '动态详情' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/dynamicInfo/dynamicInfo')
  },
  {
    path: '/dynamic',
    name: 'dynamic',
    meta: { title: '医院动态' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/dynamic/dynamic')
  },
  {
    path: '/keshijieshao',
    name: 'keshijieshao',
    meta: { title: '科室介绍' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/keshijieshao/keshijieshao')
  },
  {
    path: '/yishengjieshao',
    name: 'yishengjieshao',
    meta: { title: '医生介绍' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/yishengjieshao/yishengjieshao')
  },
  {
    path: '/yishengDetails',
    name: 'yishengDetails',
    meta: { title: '医生介绍详情' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/yishengjieshao/yishengDetails')
  },
  {
    path: '/loucengfenbu',
    name: 'loucengfenbu',
    meta: { title: '楼层分布' },
    component: () => import(/* webpackChunkName: "hospital" */ '../views/loucengfenbu/loucengfenbu')
  }
]
